import styled from "styled-components";

import { TextField } from "@similarweb/ui-components/forms";

export const RECIPIENT_CONTACTS_DROPDOWN_WIDTH = "320px";
export const RECIPIENT_CONTACTS_INPUT_FIELD_WIDTH = "310px";

export const StyledRecipientTextField = styled(TextField)`
    && {
        width: ${RECIPIENT_CONTACTS_INPUT_FIELD_WIDTH};
        max-width: ${RECIPIENT_CONTACTS_INPUT_FIELD_WIDTH};
        box-sizing: border-box;
    }

    & [data-slot="control"] {
        min-width: ${RECIPIENT_CONTACTS_INPUT_FIELD_WIDTH};
        width: ${RECIPIENT_CONTACTS_INPUT_FIELD_WIDTH};
        max-width: ${RECIPIENT_CONTACTS_INPUT_FIELD_WIDTH};
        box-sizing: border-box;
    }

    & input {
        min-width: 0;
        width: 100%;
        box-sizing: border-box;
    }
`;
